import { useEffect } from "react";
import { useSnackbar } from "notistack";
import { useTranslate } from "@tolgee/react";
import { consumeGoogleAccountLinked } from "tools/auth/googleSignIn";

/**
 * Tells a person who already had a password that their Google account is now
 * linked. The flag is written on the login page and read here, inside the app
 * shell, so the toast lands on the portal page they arrive at rather than on
 * the login page they are leaving.
 */
export const useGoogleLinkedToast = (): void => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslate();

  useEffect(() => {
    if (!consumeGoogleAccountLinked()) return;

    // Default (dark) variant, bottom-left — matches the design and every other
    // snackbar in the app.
    enqueueSnackbar(t("global.login.google_linked_toast"));
  }, [enqueueSnackbar, t]);
};

export default useGoogleLinkedToast;
